import { render, staticRenderFns } from "./ApexRadialBarChart.vue?vue&type=template&id=56e59daa&"
import script from "./ApexRadialBarChart.vue?vue&type=script&lang=js&"
export * from "./ApexRadialBarChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports